import { checkFullLink } from "@wion-spa/shared/utils";
const ROUTE_REMOTE_LOADER = "route";
export function joinUrl(baseUrl, path) {
    return `${baseUrl.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
}
export function toMfManifestUrl(remoteUrl) {
    const url = remoteUrl.trim();
    const [, pathname, suffix = ""] = url.match(/^([^?#]*)(.*)$/) ?? [];
    if (!pathname)
        return url;
    if (pathname.toLowerCase().endsWith(".json"))
        return url;
    const remoteBaseUrl = pathname
        .replace(/\/[^/]*\.(?:mjs|js)$/i, "")
        .replace(/\/+$/, "");
    return `${remoteBaseUrl}/mf-manifest.json${suffix}`;
}
function usesRouteRemoteLoader(remote) {
    return remote?.config["remoteLoader"] === ROUTE_REMOTE_LOADER;
}
function getRemoteAssetsBaseUrl(remoteUrl) {
    const remoteBaseUrl = remoteUrl.replace(/\/remoteEntry\.m?js(?:[?#].*)?$/, "");
    return joinUrl(remoteBaseUrl, "assets");
}
function resolveRemoteConfig(remote, resolvedRemoteUrl, adminAssetsBaseUrl) {
    if (remote.config.assetsBaseUrl === "/assets") {
        return { ...remote.config, assetsBaseUrl: adminAssetsBaseUrl };
    }
    if (!remote.config.assetsBaseUrl && remote.config["i18n"]) {
        return {
            ...remote.config,
            assetsBaseUrl: getRemoteAssetsBaseUrl(resolvedRemoteUrl),
        };
    }
    return remote.config;
}
export function resolveMfManifest(manifest, baseUrl, isLocal) {
    const adminAssetsBaseUrl = isLocal
        ? "/assets"
        : joinUrl(baseUrl, "apps/admin/assets");
    const remoteUrls = {};
    const remotes = Object.fromEntries(Object.entries(manifest.remotes).map(([name, remote]) => {
        const resolvedRemoteUrl = isLocal
            ? remote.url
            : checkFullLink(remote.url, joinUrl(baseUrl, remote.url));
        remoteUrls[name] = resolvedRemoteUrl;
        return [
            name,
            {
                ...remote,
                url: resolvedRemoteUrl,
                config: resolveRemoteConfig(remote, resolvedRemoteUrl, adminAssetsBaseUrl),
            },
        ];
    }));
    return {
        manifest: { ...manifest, remotes },
        remoteUrls,
    };
}
/**
 * Route loading requires MF 2.0 descriptors, while @wi-mfes/config must retain the original
 * remote URLs used by asset and i18n resolution. Keep the two states separate.
 */
export function createRouteRemoteLoaderState({ manifest, }) {
    const remotes = Object.fromEntries(Object.entries(manifest.remotes)
        .filter(([, remote]) => usesRouteRemoteLoader(remote))
        .map(([name, remote]) => {
        const url = toMfManifestUrl(remote.url);
        return [name, { ...remote, url }];
    }));
    return {
        manifest: { ...manifest, remotes },
        remoteUrls: Object.fromEntries(Object.entries(remotes).map(([name, remote]) => [name, remote.url])),
    };
}
export function getRuntimeRemoteUrls({ manifest, remoteUrls, }) {
    return Object.fromEntries(Object.entries(remoteUrls).filter(([name]) => !usesRouteRemoteLoader(manifest.remotes[name])));
}
//# sourceMappingURL=mf-manifest.utils.js.map